import sortBy from 'lodash/sortBy';

/////// -------------------------------------------------
import { applyTemplate } from './ListApplyTemplate';
import { closeParenthesis, openParenthesis } from './ListParenthesis';
import { dataType } from './ListDataType';
import { highlightCondition, highlightColor } from './ListHighlight';
import { listPortletDisplayType, listPortletType, listPortletViewType } from './ListPortlet';
import { operator } from './ListOperator';
import { saleTags, tillSummaryTags, chitTags } from './templateTags';
import { searchRecordAggregation, searchRecordOrder } from './ListAggregation';
import { searchRecordGraphType } from './ListGraphs';
import { translate } from './ListHelper';
import contactNumberType from './ListContactNumberType';
import couponType from './ListCouponType';
import creditType from './ListCreditType';
import customFieldType from './ListCustomFieldType';
import customTabType from './ListCustomTabType';
import deliveryStatus from './ListDeliveryStatus';
import deliveryType from './ListDeliveryType';
import deviceStatus from './ListDeviceStatus';
import eventInterval from './ListEventInterval';
import eventScheduleType from './ListEventScheduleType';
import eventTrigger from './ListEventTrigger';
import eventType from './ListEventType';
import frequency from './ListFrequency';
import gender from './ListGender';
import hour from './ListHour';
import importType from './ListImportType';
import inventoryStatus from './ListInventoryStatus';
import itemType from './ListItemType';
import itemTypeFiltered from './ListItemTypeFiltered';
import kafkaLogTopicCtx from './ListKafkaLogTopicCtx';
import locationType from './ListLocationType';
import minute from './ListMinute';
import day from './ListDay';
import month from './ListMonth';
import netsuiteIntegrationMethod from './ListNetsuiteIntegrationMethod';
import omsStatus from './ListOmsStatus';
import orderMethod from './ListOrderMethod';
import period from './ListPeriod';
import preference_setting from './ListPreference_setting';
import printerBrand from './ListPrinterBrand';
import epsonPrinterSeries from './ListEpsonPrinterSeries';
import epsonPrinterLang from './ListEpsonPrinterLang';
import priority_level from './ListPriorityLevel';
import promoCategoryType from './promoCategoryType';
import promotionCategoryType from './ListPromoCategoryType';
import promotionType from './promotionType';
import setSellPriceTo from './ListSetSellPriceTo';
import shortcutType from './ListShortcutType';
import subLocationMappingType from './ListSubLocationMappingType';
import templateOrientation from './ListTemplateOrientation';
import templateOutputType from './templateOutputType';
import templateSize from './ListTemplateSize';
import templateType from './ListTemplateType';
import timezone from './ListTimezone';

/////// -------------------------------------------------

import transactionStatus from './transactionStatus';
import transactionType from './transactionType';
import voidAuditType from './voidAuditType';

/////// -------------------------------------------------
export const lists = {
  APPLY_TEMPLATE: (intl) => translate(intl, applyTemplate),
  CLOSE_PARENTHESIS: (intl) => translate(intl, closeParenthesis),
  CONTACT_NUMBER_TYPE: (intl) => translate(intl, contactNumberType),
  COUPON_TYPE: (intl) => translate(intl, couponType),
  CREDIT_TYPE: (intl) => translate(intl, creditType),
  CUSTOM_FIELD_TYPE: (intl) => translate(intl, customFieldType),
  CUSTOM_TAB_TYPE: (intl) => translate(intl, customTabType),
  DATA_TYPE: (intl) => translate(intl, dataType),
  DELIVERY_STATUS: (intl) => translate(intl, deliveryStatus),
  DELIVERY_TYPE: (intl) => translate(intl, deliveryType),
  DEVICE_STATUS: (intl) => translate(intl, deviceStatus),
  EVENT_INTERVAL: (intl) => translate(intl, eventInterval),
  EVENT_SCHEDULE_TYPE: (intl) => translate(intl, eventScheduleType),
  EVENT_TRIGGER: (intl) => translate(intl, eventTrigger),
  EVENT_TYPE: (intl) => translate(intl, eventType),
  FREQUENCY: (intl) => translate(intl, frequency),
  GENDER: (intl) => translate(intl, gender),
  HIGHLIGHT_COLOR: (intl) => translate(intl, highlightColor),
  HIGHLIGHT_CONDITION: (intl) => translate(intl, highlightCondition),
  HOUR: hour,
  IMPORT_TYPE: (intl) => translate(intl, importType),
  INVENTORY_STATUS: (intl) => translate(intl, inventoryStatus),
  ITEM_TYPE_FILTERED: (intl) => translate(intl, itemTypeFiltered),
  ITEM_TYPE: (intl) => translate(intl, itemType),
  KAFKA_LOG_TOPIC_CTX: (intl) => translate(intl, kafkaLogTopicCtx),
  LOCATION_TYPE: (intl) => translate(intl, locationType),
  MINUTE: minute,
  MONTH: (intl) => translate(intl, month),
  NETSUITE_INTEGRATION_METHOD: (intl) => translate(intl, netsuiteIntegrationMethod),
  OMS_STATUS: (intl) => translate(intl, omsStatus),
  OPEN_PARENTHESIS: (intl) => translate(intl, openParenthesis),
  OPERATOR: (intl) => translate(intl, operator),
  ORDER_METHOD: (intl) => translate(intl, orderMethod),
  PERIOD: (intl) => translate(intl, period),
  PORTLET_DISPLAY_TYPE: (intl) => translate(intl, listPortletDisplayType),
  PORTLET_TYPE: (intl) => translate(intl, listPortletType),
  PORTLET_VIEW_TYPE: (intl) => translate(intl, listPortletViewType),
  PREFERENCE_SETTING: (intl) => translate(intl, preference_setting, 'label'),
  PRINTER_BRAND: printerBrand,
  EPSON_PRINTER_SERIES: epsonPrinterSeries,
  EPSON_PRINTER_LANG: epsonPrinterLang,
  PRIORITY_LEVEL: (intl) => translate(intl, priority_level),
  PROMOTION_CATEGORY_TYPE: (intl) => translate(intl, promotionCategoryType),
  SEARCH_RECORD_AGGREGATION: (intl) => translate(intl, searchRecordAggregation),
  SEARCH_RECORD_GRAPH_TYPES: (intl) => translate(intl, searchRecordGraphType),
  SEARCH_RECORD_ORDER: (intl) => translate(intl, searchRecordOrder),
  SET_SELL_PRICE_TO: (intl) => translate(intl, setSellPriceTo),
  SHORTCUT_TYPE: (intl) => translate(intl, shortcutType),
  SUB_LOCATION_MAPPING_TYPE: (intl) => translate(intl, subLocationMappingType),
  TEMPLATE_ORIENTATION: (intl) => translate(intl, templateOrientation),
  TEMPLATE_SIZE: (intl) => translate(intl, templateSize),
  TEMPLATE_TYPE: (intl) => translate(intl, templateType),
  TIMEZONE: (intl) => translate(intl, timezone),
  DAY: (intl) => translate(intl, day),
};
/////// -------------------------------------------------

// export { default as importType } from './importType';
export { default as importType } from './ListImportType';

const allLists = {
  chitTags,
  couponType,
  creditType,
  customFieldType,
  deliveryStatus,
  deliveryType,
  deviceStatus,
  eventType,
  frequency,
  hour,
  importType,
  inventoryStatus,
  itemType,
  locationType,
  minute,
  preference_setting,
  promoCategoryType,
  promotionType,
  saleTags,
  subLocationMappingType,
  templateOrientation,
  templateOutputType,
  templateSize,
  templateType,
  tillSummaryTags,
  timezone,
  transactionStatus,
  transactionType,
  voidAuditType,
};

export default allLists;

export function listOptions(listId) {
  const list = allLists[listId];
  if (list && Array.isArray(list)) {
    return sortBy(list, 'name'); // TODO: ensure all lists have name value
  }
  return [];
}

export function listValue(listId, valueId) {
  const value = listOptions.filter((item) => {
    return item.id === valueId || item.value === valueId;
  });
  if (value.length === 1) {
    return value[0];
  }
  return {};
}
